import { render, staticRenderFns } from "./NewBatteryIndicator.vue?vue&type=template&id=4ff2a1ac&scoped=true"
import script from "./NewBatteryIndicator.vue?vue&type=script&lang=js"
export * from "./NewBatteryIndicator.vue?vue&type=script&lang=js"
import style0 from "./NewBatteryIndicator.vue?vue&type=style&index=0&id=4ff2a1ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff2a1ac",
  null
  
)

export default component.exports